"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PimGroupCustAlsoBoughtActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["PimGroupCustAlsoBoughtEvent"] = "PimGroupCustAlsoBoughtEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var PimGroupCustAlsoBoughtActions;
(function (PimGroupCustAlsoBoughtActions) {
    PimGroupCustAlsoBoughtActions["PimGroupCustAlsoBoughtCreated"] = "PimGroupCustAlsoBoughtCreated";
    PimGroupCustAlsoBoughtActions["PimGroupCustAlsoBoughtUpdated"] = "PimGroupCustAlsoBoughtUpdated";
    PimGroupCustAlsoBoughtActions["PimGroupCustAlsoBoughtDeleted"] = "PimGroupCustAlsoBoughtyDeleted";
    PimGroupCustAlsoBoughtActions["CreatePimGroupCustAlsoBought"] = "CreatePimGroupCustAlsoBought";
    PimGroupCustAlsoBoughtActions["UpdatePimGroupCustAlsoBought"] = "UpdatePimGroupCustAlsoBought";
    PimGroupCustAlsoBoughtActions["DeletePimGroupCustAlsoBought"] = "DeletePimGroupCustAlsoBought";
})(PimGroupCustAlsoBoughtActions = exports.PimGroupCustAlsoBoughtActions || (exports.PimGroupCustAlsoBoughtActions = {}));
